import { Api } from './base';

const _headers = () => {
  return {
    Authorization:
      "JWT " + require("store").default.getState().onboard.user.auth_token,
    "Content-Type": "application/json"
  };
};

const getWordsInfo = (offset = 0, search = '', themes = '') => {
  let url = `/wg_and_pictionary/v1/admin-words-info?offset=${offset}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  if (themes) url += `&themes=${encodeURIComponent(themes)}`;
  return Api.getRequest(url, _headers());
};

const getWordInfo = (id) => {
  return Api.get(`/wg_and_pictionary/v1/admin-words-info/${id}`, _headers());
};

const createWordInfo = (payload) => {
  return Api.post(`/wg_and_pictionary/v1/admin-words-info`, payload, _headers());
};

const updateWordInfo = (id, payload) => {
  return Api.put(`/wg_and_pictionary/v1/admin-words-info/${id}`, payload, _headers());
};

const deleteWordInfo = (id) => {
  return Api.deleteCall(`/wg_and_pictionary/v1/admin-words-info/${id}`, _headers());
};

export default {
  getWordsInfo,
  getWordInfo,
  createWordInfo,
  updateWordInfo,
  deleteWordInfo,
};
